// import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
// import { useState } from "react";
// import { MsalProvider } from "@azure/msal-react";
// import { useMsal } from "@azure/msal-react";
// import { msalConfig, loginRequest } from './msalAuth';
// import { PublicClientApplication, EventType } from "@azure/msal-browser";
// import { AccessTokenCacheItem } from 'msal/lib-commonjs/cache/AccessTokenCacheItem';

import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';
import { msalConfig } from './msalAuth';
import { PublicClientApplication } from "@azure/msal-browser";
const msalInstance = new PublicClientApplication(msalConfig);
const authProvider = async(type, params = {}) => {

    if (type === AUTH_LOGIN) {
        if (!params.idToken) {
            return;
        }

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ account: params.account, token: params.idToken }),
        });

        if (!response.ok) {
            // cleanup();
            return Promise.reject();
        }

        localStorage.setItem('token', params.idToken);
        return Promise.resolve();
    }

    if ([AUTH_LOGOUT, AUTH_ERROR].includes(type)) {
        localStorage.removeItem('token');
        return Promise.resolve();
    }

    if (type === AUTH_CHECK) {
        //TODO: token storage is probably not needed because MSAL does this itself.
        const token = localStorage.getItem('token');
        if (!token) {
            console.log("AUTH_CHECK: no token found");
            return Promise.reject();
        }

        const account = msalInstance.getActiveAccount();
        if (!account) {
            console.log("AUTH_CHECK: no account found");
            return Promise.reject();
        }

        const now = new Date();
        return now.getTime() > (account.idTokenClaims.exp * 1000) ? Promise.reject() : Promise.resolve();
    }


    return Promise.resolve()
}

export default authProvider;